import * as THREE from 'three';

class TouchControls {
  constructor(canvas, controls) {
    this.canvas = canvas;
    this.controls = controls;
    this.touchState = {
      touchStartX: 0,
      touchStartY: 0,
      touchStartDistance: 0,
      isPinching: false,
      lastTouchTime: 0,
      lastTouchX: 0,
      lastTouchY: 0,
      velocityX: 0,
      velocityY: 0,
      momentumInterval: null
    };
    
    // Simpan referensi handler
    this._touchStartHandler = this._handleTouchStart.bind(this);
    this._touchMoveHandler = this._handleTouchMove.bind(this);
    this._touchEndHandler = this._handleTouchEnd.bind(this);

    this._setupEventListeners();
  }

  _setupEventListeners() {
    this.canvas.style.touchAction = 'none';
    this.canvas.addEventListener('touchstart', this._touchStartHandler, { passive: false });
    this.canvas.addEventListener('touchmove', this._touchMoveHandler, { passive: false });
    this.canvas.addEventListener('touchend', this._touchEndHandler, { passive: true });
  }

  _handleTouchStart(event) {
    if (event.touches.length === 1) {
      const touch = event.touches[0];
      this.touchState.touchStartX = touch.clientX;
      this.touchState.touchStartY = touch.clientY;
      this.touchState.lastTouchX = touch.clientX;
      this.touchState.lastTouchY = touch.clientY;
      this.touchState.lastTouchTime = Date.now();
      if (this.touchState.momentumInterval) clearInterval(this.touchState.momentumInterval);
    } else if (event.touches.length === 2) {
      this.touchState.isPinching = true;
      const [touch1, touch2] = event.touches;
      this.touchState.touchStartDistance = Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);
      event.preventDefault();
    }
  }

  _handleTouchMove(event) {
    if (event.touches.length === 1 && !this.touchState.isPinching) {
      const touch = event.touches[0];
      const deltaTime = Date.now() - this.touchState.lastTouchTime;
      if (deltaTime > 0) {
        this.touchState.velocityX = (touch.clientX - this.touchState.lastTouchX) / deltaTime * 16;
        this.touchState.velocityY = (touch.clientY - this.touchState.lastTouchY) / deltaTime * 16;
      }
      const deltaX = touch.clientX - this.touchState.touchStartX;
      const deltaY = touch.clientY - this.touchState.touchStartY;
      this.controls.panLeft(deltaX * 0.002);
      this.controls.panUp(deltaY * 0.002);
      this.controls.update();
      this.touchState.lastTouchX = touch.clientX;
      this.touchState.lastTouchY = touch.clientY;
      this.touchState.lastTouchTime = Date.now();
      this.touchState.touchStartX = touch.clientX;
      this.touchState.touchStartY = touch.clientY;
      event.preventDefault();
    } else if (event.touches.length === 2 && this.touchState.isPinching) {
      const [touch1, touch2] = event.touches;
      const currentDistance = Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);
      const zoomDelta = (currentDistance - this.touchState.touchStartDistance) * 0.01;
      this.controls.dollyOut(zoomDelta);
      this.controls.update();
      this.touchState.touchStartDistance = currentDistance;
      event.preventDefault();
    }
  }

  _handleTouchEnd(event) {
    if (event.touches.length === 0) {
      this.touchState.isPinching = false;
      if (Math.abs(this.touchState.velocityX) > 0.5 || Math.abs(this.touchState.velocityY) > 0.5) {
        this._applyMomentum();
      }
    }
  }

  _applyMomentum() {
    if (this.touchState.momentumInterval) clearInterval(this.touchState.momentumInterval);
    this.touchState.momentumInterval = setInterval(() => {
      if (Math.abs(this.touchState.velocityX) < 0.1 && Math.abs(this.touchState.velocityY) < 0.1) {
        clearInterval(this.touchState.momentumInterval);
        this.touchState.momentumInterval = null;
        return;
      }
      this.controls.panLeft(this.touchState.velocityX * 0.002);
      this.controls.panUp(this.touchState.velocityY * 0.002);
      this.controls.update();
      this.touchState.velocityX *= 0.95;
      this.touchState.velocityY *= 0.95;
    }, 16);
  }

  cleanup() {
    if (this.canvas) {
      // Hapus event listener menggunakan referensi yang disimpan
      this.canvas.removeEventListener('touchstart', this._touchStartHandler);
      this.canvas.removeEventListener('touchmove', this._touchMoveHandler);
      this.canvas.removeEventListener('touchend', this._touchEndHandler);
    }
    if (this.touchState && this.touchState.momentumInterval) {
      clearInterval(this.touchState.momentumInterval);
      this.touchState.momentumInterval = null;
    }
  }
}

export default TouchControls;